

import React from 'react';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import MDAvatar from "components/MDAvatar";

const AvatarFrame = styled(Box)(({ theme, size = 40 }) => ({
  width: size,
  height: size,
  borderRadius: size === 150 ? 8 : '50%', // Profile uses 8px radius, navbar uses circular
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#E8EEF7',
  border: size === 150 ? '4px solid white' : 'none', // Only profile avatar has border
  boxShadow: size === 150 ? '0 4px 20px 0 rgba(0,0,0,0.14)' : 'none', // Only profile avatar has shadow
  color: '#7A8BA8',
  overflow: 'hidden',
}));

const getInitials = (firstName = '', middleName = '', lastName = '') => {
  const initials = [firstName, lastName]
    .filter(name => name) // Filter out empty/null values
    .map(name => name[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
  
  return initials;
};

function MDUserAvatar({ 
  firstName, 
  middleName, 
  lastName, 
  avatarUrl, 
  size = 40, // Default size for navbar
  variant = "circular", // Default variant for navbar
  onClick  // Add onClick prop
}) {
  if (avatarUrl) {
    return (
      <MDAvatar
        src={avatarUrl}
        alt={`${firstName} ${lastName}`}
        size={size === 150 ? "xxl" : "sm"}
        variant={variant}
        onClick={onClick}
        sx={{
          width: size,
          height: size,
          ...(size === 150 && {
            border: '4px solid white',
            boxShadow: '0 4px 20px 0 rgba(0,0,0,0.14)',
          }),
          backgroundColor: '#1565C8', // Fallback if image fails to load
          '& img': {
            width: '100%',
            height: '100%',
            objectFit: 'cover'  // This will make the image stretch
          }
        }}
      />
    );
  }

  const initials = getInitials(firstName, middleName, lastName);

  return (
    <AvatarFrame size={size} onClick={onClick}>
      {initials ? (
        <Box
          component="span"
          sx={{
            color: '#1565C8',
            fontSize: size === 150 ? '3rem' : '1rem',
            fontWeight: 'bold',
          }}
        >
          {initials}
        </Box>
      ) : (
        <PersonOutlineIcon sx={{ fontSize: size === 150 ? 72 : size * 0.55 }} />
      )}
    </AvatarFrame>
  );
}

export default MDUserAvatar; 